<template>
  <div style="height: 100%;overflow: auto;">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="lastHeaderColumns">
        <li class="main-table-cell">
          <div class="main-table-cell-wrap">
            <span class="main-table-txt">触发器管理</span>
          </div>
        </li>
      </template>
      <template slot="lastBodyColumns" slot-scope="props">
        <li class="main-table-cell">
          <div class="main-table-cell-wrap">
          <span class="main-table-txt">
            <grid-menu-a
              style="color: #677de0;"
              @menu-click="changeRouterToTrigger(props.row)"
              name="触发器管理"
            >
            </grid-menu-a>
          </span>
          </div>
        </li>
      </template>
      <template slot="topSelectMenus">
        <grid-menu-a
          name="开启任务"
          style="margin-right: 3px;"
          class="btn btn-hollow-dark"
          @menu-click="startJob"
        >
        </grid-menu-a>
        <grid-menu-a
          name="暂停任务"
          style="margin-right: 3px;"
          class="btn btn-hollow-dark"
          @menu-click="suspendJob"
        >
        </grid-menu-a>
      </template>
    </grid>
  </div>
</template>

<script>
  import Grid from '../../../../components/grid/grid'
  import GridMenuA from '../../../../components/grid-menu/grid-menu-a'
  import util from '@/libs/util'
  export default {
    components: {
      GridMenuA,
      Grid
    },
    name: 'schedule-job',
    data() {
      return {
        gridConfigUrl: '/entity/scheduler/scheduleJobManage/abstractGrid',
        clientId: this.$route.query.clientId
      }
    },
    methods: {
      changeRouterToTrigger: function (row) {
        util.changeRouter(this, {
          name: 'scheduleTrigger',
          query: {
            jobKey: row.key,
            clientId: this.clientId
          }
        })
      },
      startJob: function () {
        let keys = this.$refs.myGrid.checkedRows
        if (keys.length !== 1) {
          this.$notify.warning({title: '警告', message: '请选择一条数据'})
          return
        }
        this.$confirm('确定开启定时调度吗？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          util.ajax.put('/entity/scheduler/scheduleJobManage/' + keys[0] + '/status?clientId=' + this.clientId + '&isStart=true').then(res => {
            if (res.data.meta.errCode === 0) {
              this.$notify.success({title: '成功', message: '开启成功'})
              this.$refs.myGrid.loadTableData()
            } else {
              this.$notify.warning({title: '错误', message: res.data.meta.errMsg})
            }
          }).catch(err => {
            console.error(err)
            this.$notify.error({title: '错误', message: '系统错误'})
          })
        }).catch()
      },
      suspendJob: function () {
        let keys = this.$refs.myGrid.checkedRows
        if (keys.length !== 1) {
          this.$notify.warning({title: '警告', message: '请选择一条数据'})
          return
        }
        this.$confirm('确定暂停定时调度吗？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          util.ajax.put('/entity/scheduler/scheduleJobManage/' + keys[0] + '/status?clientId=' + this.clientId + '&isStart=false').then(res => {
            if (res.data.meta.errCode === 0) {
              this.$notify.success({title: '成功', message: '暂停成功'})
              this.$refs.myGrid.loadTableData()
            } else {
              this.$notify.warning({title: '错误', message: res.data.meta.errMsg})
            }
          }).catch(err => {
            console.error(err)
            this.$notify.error({title: '错误', message: '系统错误'})
          })
        }).catch()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/grid/scheduler/schedule-job.vue